import { useState, useEffect } from 'react';
import { TrendingUp, AlertCircle, Users, Euro } from 'lucide-react';
import './Inici.css';
import API_URL from '../config';

function Inici({ canviarSeccio }) {
  const [dadesKPI, setDadesKPI] = useState(null);
  const [paquets, setPaquets] = useState([]);
  const [carregant, setCarregant] = useState(true);
  const [error, setError] = useState('');
  const [registresHoraris, setRegistresHoraris] = useState([]);
  const [ultimsPaquets, setUltimsPaquets] = useState([]);
  const [clientsRisc, setClientsRisc] = useState([]);


  useEffect(() => {
    carregarDadesKPI();
    carregarPaquets();
    carregarRegistresHoraris();
    carregarUltimsPaquets(); 
    carregarClientsRisc();
  }, []);

  const carregarDadesKPI = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      setError('No estàs autenticat');
      setCarregant(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/business/rendibilitat/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setDadesKPI(data);
        setError('');
      } else {
        setError('Error carregant les dades');
      }
    } catch (err) {
      setError(`Error de connexió: ${err.message}`);
    } finally {
      setCarregant(false);
    }
  };

  const carregarPaquets = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) return;

    try {
      const response = await fetch(`${API_URL}/api/gestio/paquets/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setPaquets(data);
      }
    } catch (err) {
      console.error('Error carregant paquets:', err);
    }
  };

  const carregarUltimsPaquets = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) return;

    try {
      const response = await fetch(`${API_URL}/api/gestio/paquets/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setUltimsPaquets(data.slice(0, 5)); // Només els 5 primers
      }
    } catch (err) {
      console.error('Error carregant últims paquets:', err);
    }
  };

  const carregarClientsRisc = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) return;

    try {
      const response = await fetch(`${API_URL}/api/gestio/risc/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setClientsRisc(data.slice(0, 5)); // Només els 5 primers
      }
    } catch (err) {
      console.error('Error carregant clients amb risc:', err);
    }
  };


  const carregarRegistresHoraris = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) return;

    try {
      const response = await fetch(`${API_URL}/api/gestio/hores/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setRegistresHoraris(data);
      }
    } catch (err) {
      console.error('Error carregant registres horaris:', err);
    }
  };

  const calcularClientsActius = () => { // Aquesta funció calcula el nombre de clients amb paquets actius
    return paquets.filter(paquet => paquet.sessions_restants > 0).length;
  };

  const calcularIngressosMesActual = () => { // Aquesta funció calcula els ingressos del mes actual
    const avui = new Date();
    const mesActual = avui.getMonth();
    const anyActual = avui.getFullYear();

    const ingressos = paquets // Filtrar paquets comprats en el mes actual i sumar els seus preus totals
      .filter(paquet => {
        const dataCompra = new Date(paquet.data_compra);
        return dataCompra.getMonth() === mesActual && dataCompra.getFullYear() === anyActual;
      })
      .reduce((total, paquet) => total + parseFloat(paquet.preu_total), 0);

    return ingressos.toFixed(2); // Retornem els ingressos amb dos decimals
  };

  const esAquestaSetmana = (data) => { // Funció per comprovar si una data està dins de la setmana actual
    const avui = new Date();
    const diaSetmana = avui.getDay(); // 0=diumenge, 1=dilluns, 2=dimarts... Aixo ens ajuda a trobar el primer dia de la setmana
    
    // Si és diumenge (0), resta 6 dies. Si no, resta (diaSetmana - 1). Aixi arribem a dilluns
    const diesAResta = diaSetmana === 0 ? 6 : diaSetmana - 1; //
    
    const primerDiaSetmana = new Date(avui);
    primerDiaSetmana.setDate(avui.getDate() - diesAResta); // Anem al dilluns d'aquesta setmana
    primerDiaSetmana.setHours(0, 0, 0, 0); // Posem l'hora a l'inici del dia

    const ultimDiaSetmana = new Date(primerDiaSetmana); 
    ultimDiaSetmana.setDate(primerDiaSetmana.getDate() + 6); // Anem al diumenge d'aquesta setmana
    ultimDiaSetmana.setHours(23, 59, 59, 999); // Posem l'hora al final del dia

    const dataRegistre = new Date(data); 
    return dataRegistre >= primerDiaSetmana && dataRegistre <= ultimDiaSetmana; // Comprovem si la data del registre està dins del rang de la setmana actual
  };


  const calcularTasquesCompletades = () => { // Comptem els registres horaris que tenen hora_final dins d'aquesta setmanai per tant estan completats
  return registresHoraris.filter(r => r.hora_final && esAquestaSetmana(r.hora_inici)).length;
  };

  const calcularHoresTotals = () => { // Utilitzem la mateixa funcio que haviem fet servir a controlhorari.js per calcular 
    const totalSegons = registresHoraris
      .filter(r => r.hora_final && esAquestaSetmana(r.hora_inici))
      .reduce((total, r) => {
        const inici = new Date(r.hora_inici);
        const final = new Date(r.hora_final);
        const diferencia = Math.floor((final - inici) / 1000); // Diferència en segons
        return total + diferencia;
      }, 0);

    return (totalSegons / 3600).toFixed(1); // Convertim a hores i retornem amb un decimal
  };

  const calcularTasquesEnCurs = () => {
    return registresHoraris.filter(r => !r.hora_final).length; // Compta els registres sense hora_final, per tant en curs
  };



  if (carregant) {
    return (
      <div className="zona-treball">
        <p>Carregant dades...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="zona-treball">
        <div className="missatge-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="zona-treball">
      <div className="capçalera-seccio">
        <h1>Benvingut/da de nou!</h1>
        <p>Això és el que està passant avui amb el teu negoci.</p>
      </div>

      {dadesKPI && ( // Aqui mostrarem els diferents KPIs si les dades es carregen bé sense errors
        <div className="graella-targetes">
          {/* KPI 1: Rendibilitat neta */}
          <div className="targeta-metrica"
            onClick={() => canviarSeccio('rendibilitat')}
            style={{ cursor: 'pointer' }}
            >
            <div>
              <span className="titol-metrica">Rendibilitat neta</span>
              <span className="valor-metrica">{parseFloat(dadesKPI.guany_net).toFixed(2)} €</span> {/* Mostrem el guany net amb dos decimals */}
            </div>
            <div className="icona-contenidor blau">
              <TrendingUp size={20} />
            </div>
          </div>

          {/* KPI 2: Clients en risc */}
          <div className="targeta-metrica"
            onClick={() => document.getElementById('taula-clients-risc')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
            style={{ cursor: 'pointer' }}
            >
            <div>
              <span className="titol-metrica">Clients en risc</span>
              <span className="valor-metrica">{dadesKPI.num_paquets_risc_abandonament}</span> {/* Mostrem el nombre de paquets en risc d'abandonament */}
              <span className="text-secundari vermell">Acció requerida</span>
            </div>
            <div className="icona-contenidor vermell">
              <AlertCircle size={20} />
            </div>
          </div>

          {/* KPI 3: Paquets/Clients actius */}
          <div className="targeta-metrica targeta-clicable"
            onClick={() => canviarSeccio('paquets')}
            style={{ cursor: 'pointer' }}
            >
            <div>
              <span className="titol-metrica">Paquets actius</span>
              <span className="valor-metrica">{calcularClientsActius()}</span> {/* Mostrem el nombre de clients amb paquets actius */}
              <span className="text-secundari gris">Amb sessions disponibles</span>
            </div>
            <div className="icona-contenidor lila">
              <Users size={20} />
            </div>
          </div>

          {/* KPI 4: Ingressos mes actual */}
          <div className="targeta-metrica"
            onClick={() => canviarSeccio('rendibilitat')}
            style={{ cursor: 'pointer' }}
            >
            <div>
              <span className="titol-metrica">Ingressos aquest mes</span>
              <span className="valor-metrica">{calcularIngressosMesActual()} €</span> {/* Mostrem els ingressos totals del mes actual */}
              <span className="text-secundari verd">Vendes mensuals</span>
            </div>
            <div className="icona-contenidor verd">
              <Euro size={20} />
            </div>
          </div>
        </div>
      )}

      {/* Quadres inferiors */}
      {/* Resum setmanal d'activitat */}
      <div className="contenidor-grafic">
        <h2>Resum d'activitat aquesta setmana</h2>
        <div className="resum-setmana">
          <div className="estat-resum">
            <span className="numero-gran">{calcularTasquesCompletades()}</span>
            <span className="text-petit">Tasques completades</span>
          </div>
          <div className="estat-resum">
            <span className="numero-gran">{calcularHoresTotals()}</span>
            <span className="text-petit">Hores totals invertides</span>
          </div>
          <div className="estat-resum">
            <span className="numero-gran">{calcularTasquesEnCurs()}</span>
            <span className="text-petit">Tasca en curs</span>
          </div>
        </div>
      </div>

      {/* Últims paquets venuts */}
      <div className="quadre-inferior">
        <h2>Últims paquets venuts</h2>
        {ultimsPaquets.length === 0 ? (
          <p className="missatge-buit">No hi ha paquets venuts encara.</p>
        ) : (
          <table className="taula-quadre-inf">
            <thead>
              <tr>
                <th>Client</th>
                <th>Sessions</th>
                <th>Preu</th>
                <th>Data compra</th>
              </tr>
            </thead>
            <tbody>
              {ultimsPaquets.map(paquet => (
                <tr key={paquet.id}>
                  <td><strong>{paquet.nom_client}</strong></td>
                  <td>{paquet.sessions_comprades}</td>
                  <td>{paquet.preu_total}€</td>
                  <td>{new Date(paquet.data_compra).toLocaleDateString('ca-ES')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Clients en risc d'abandonament */}
    <div className="quadre-inferior" id="taula-clients-risc">
      <h2>Clients amb risc d'abandonament</h2>
      {clientsRisc.length === 0 ? (
        <p className="missatge-buit">No hi ha clients amb risc actualment.</p>
      ) : (
        <table className="taula-quadre-inf">
          <thead>
            <tr>
              <th>Client</th>
              <th>Sessions restants</th>
              <th>Data compra</th>
            </tr>
          </thead>
          <tbody>
            {clientsRisc.map(paquet => (
              <tr key={paquet.id}>
                <td><strong>{paquet.nom_client}</strong></td>
                <td>
                  <span className={paquet.sessions_restants === 0 ? 'risc-alt' : 'risc-mig'}>
                    {paquet.sessions_restants}
                  </span>
                </td>
                <td>{new Date(paquet.data_compra).toLocaleDateString('ca-ES')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>


    </div>
  );
}

export default Inici;
